import { render, staticRenderFns } from "./ExternalManagers.vue?vue&type=template&id=496dcbe4&scoped=true&"
import script from "./ExternalManagers.vue?vue&type=script&lang=ts&"
export * from "./ExternalManagers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496dcbe4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('496dcbe4')) {
      api.createRecord('496dcbe4', component.options)
    } else {
      api.reload('496dcbe4', component.options)
    }
    module.hot.accept("./ExternalManagers.vue?vue&type=template&id=496dcbe4&scoped=true&", function () {
      api.rerender('496dcbe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/account/ExternalManagers.vue"
export default component.exports